const Template = () => {
  return (
    // <div
    //   style={{
    //     width: '100vw',
    //     height: '100vh',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     padding: '30px 0',
    //     color: 'black',
    //   }}>

    // </div>
    <div
      style={{
        width: 400,
        backgroundColor: '#fdf0d5',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 30,
        color: 'black',
      }}>
      <p>Uau! Delivery</p>
      <h3>TREM BÃO PÃO DE QUEIJARIA</h3>
      <p
        style={{
          textAlign: 'center',
          margin: '10px 0',
        }}>
        <b>
          Endereço: Rua José Francisco Mendes, 26 Centro - Paracatu (Atrás
          prefeitura municipal)
        </b>
      </p>
      <div
        style={{
          height: 1,
          width: '100%',
          backgroundColor: 'black',
          margin: '10px 0',
        }}
      />
      <h1>PRODUTOS</h1>
      <div
        style={{
          height: 1,
          width: '100%',
          backgroundColor: 'black',
          margin: '10px 0',
        }}
      />
      <div>
        <div
          style={{
            display: 'flex',
            gap: 3,
            justifyContent: 'space-between',
          }}>
          <p style={{width: '10%', fontSize: 12}}>Qnt.</p>
          <p style={{width: '50%', fontSize: 12}}>Produto</p>
          <p style={{width: '20%', fontSize: 12}}>Preço</p>
          <p style={{width: '20%', fontSize: 12}}>Total</p>
        </div>
        <div style={{display: 'flex', gap: 3, justifyContent: 'space-between'}}>
          <p style={{width: '10%', fontSize: 12}}>1</p>
          <p style={{width: '50%', fontSize: 12}}>BQ COSTELINHA SUINA</p>
          <p style={{width: '20%', fontSize: 12}}>R$ 12,90</p>
          <p style={{width: '20%', fontSize: 12}}>R$ 12,90</p>
        </div>
        <div style={{display: 'flex', gap: 3, justifyContent: 'space-between'}}>
          <p style={{width: '10%', fontSize: 12}}>1</p>
          <p style={{width: '50%', fontSize: 12}}>COCA COLA 310ML</p>
          <p style={{width: '20%', fontSize: 12}}>R$ 7,00</p>
          <p style={{width: '20%', fontSize: 12}}>R$ 7,00</p>
        </div>
        <div style={{display: 'flex', gap: 3, justifyContent: 'space-between'}}>
          <p style={{width: '10%', fontSize: 12}}>1</p>
          <p style={{width: '50%', fontSize: 12}}>
            MONSTER ENERGETICO LATA 1 LITRO
          </p>
          <p style={{width: '20%', fontSize: 12}}>R$ 13,00</p>
          <p style={{width: '20%', fontSize: 12}}>R$ 13,00</p>
        </div>
      </div>
      <div
        style={{
          height: 1,
          width: '100%',
          backgroundColor: 'black',
          margin: '10px 0',
        }}
      />
      <h1 style={{fontSize: 22}}>Total: R$ 29,70</h1>
      <h1>GIOVANA CARPES MALESCHA</h1>
      <p>18/09/2024 17:05</p>
      <p>Pagamento: Dinheiro - Troco para R$ 30,00</p>
    </div>
  );
};

export default Template;
